import styled from 'styled-components';
import { ArrowIcon } from '../assets';
import { TransparentButton } from '../transparent-button/TransparentButton';
export const PagesWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 2rem 2.4rem 2.2rem;
`;
export const PrevPage = styled(TransparentButton) `
  display: flex;
  align-items: center;
  justify-content: center;

  opacity: ${({ isDisabled }) => (isDisabled ? '0.5' : 'initial')};
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};

  svg {
    margin-right: 1.2rem;
  }
`;
export const Page = styled.div `
  display: none;

  ${({ theme }) => theme.media.tablet `
    display:flex;
    justify-content: center;
    align-items: center;
  `};
`;
export const ActivePage = styled(TransparentButton) `
  width: 4rem;
  height: 4rem;

  border-radius: ${({ theme }) => theme.borderRadius.medium};

  background-color: ${({ theme }) => theme.colors.interactive.secondary};

  cursor: default;
`;
export const PageButton = styled(TransparentButton) `
  width: 4rem;
  height: 4rem;
`;
export const NextPage = styled(TransparentButton) `
  display: flex;
  align-items: center;
  justify-content: center;

  opacity: ${({ isDisabled }) => (isDisabled ? '0.5' : 'initial')};
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};

  svg {
    margin-left: 1.2rem;
  }
`;
export const CustomArrowIcon = styled(ArrowIcon) `
  transform: rotate(180deg);
`;
export const MobilePage = styled.div `
  ${({ theme }) => theme.media.tablet `
    display:none;
  `};
`;
//# sourceMappingURL=styles.js.map